var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCugate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4_copy_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#037A9A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 17,
    cy: 17,
    r: 17
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.09,13.42c0.68,1.47,2.17,2.48,3.9,2.48c2.37,0,4.3-1.92,4.3-4.3c0-1.61-0.89-3.02-2.21-3.75l0,0 C15,7.56,15.98,7.4,17,7.4c5.3,0,9.6,4.3,9.6,9.6c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6C7.4,15.74,7.65,14.53,8.09,13.42 L8.09,13.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17,2.28c8.12,0,14.72,6.6,14.72,14.72S25.12,31.72,17,31.72S2.28,25.12,2.28,17S8.88,2.28,17,2.28 M17,1 C8.16,1,1,8.16,1,17s7.16,16,16,16s16-7.16,16-16S25.84,1,17,1L17,1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCugate);
export default __webpack_public_path__ + "static/media/icon-cugate.d4d9d3acaacc71187235209f8ac3eef4.svg";
export { ForwardRef as ReactComponent };